var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Type } from "class-transformer";
import { Equals, IsIn, IsNotEmpty, ValidateNested } from "class-validator";
import { DEPARTMENT_LIST } from "../../constants";
import { NewReviewBase } from "./AddReview";
export class AddProfessorRequest {
}
__decorate([
    IsIn(DEPARTMENT_LIST)
], AddProfessorRequest.prototype, "department", void 0);
__decorate([
    IsNotEmpty()
], AddProfessorRequest.prototype, "firstName", void 0);
__decorate([
    IsNotEmpty()
], AddProfessorRequest.prototype, "lastName", void 0);
__decorate([
    Equals(1)
], AddProfessorRequest.prototype, "numEvals", void 0);
__decorate([
    ValidateNested(),
    Type(() => NewReviewBase)
], AddProfessorRequest.prototype, "review", void 0);
//# sourceMappingURL=AddProfessor.js.map